import GLOBAL from '../configs/config_global';
import moment from 'moment-timezone';
import { getTimeZone } from 'react-native-localize';

export function getTruckScheduleIFrame(truckData = {}) {
    return(
        `<iframe src="https://widget.gotruckster.com/index.html?slug=${truckData.slug}" style="border:none; width:100%; height:100%;"/>`
    );
}

export function getCoverPhoto(truckData, placeholderImage = require('../images/image_blank.png'), returnStringOnly = false) {
    if (truckData) {
        let coverPhotoLength = truckData['cover_photos'] ? truckData['cover_photos'].length : 0,
            sortedArr = coverPhotoLength > 0 ? [].concat(truckData['cover_photos']).sort((a, b) => b.id - a.id) : [];

        let returnObj = coverPhotoLength > 0 ? { uri: sortedArr[0].path } : (truckData.cover_photo ? { uri: truckData.cover_photo[0].url } : placeholderImage),
            returnStr = coverPhotoLength > 0 ? sortedArr[0].path : (truckData.cover_photo ? truckData.cover_photo[0].url : placeholderImage);
        return(returnStringOnly ? returnStr : returnObj);
    }
    else return(placeholderImage);
}

export function getLogoPhoto(truckData, placeholderImage = require('../images/logo_truckster.png'), returnStringOnly = false) {
    if (truckData) {
        let checkDefaultLogo = function() {
            return(
                (truckData['logo'] && truckData['logo'].length > 0) ?
                    { uri: truckData['logo'][truckData['logo'].length - 1].url }
                    :
                    placeholderImage
            );
        };

        let returnObj =
            (
                truckData['self_logo'] ?
                    (
                        truckData['self_logo'].startsWith('http') ?
                            { uri: truckData['self_logo'] }
                            :
                            checkDefaultLogo()
                    )
                    :
                    checkDefaultLogo()
            );

        return(returnObj?.uri);
    }
    else return null;
}

// region Get Rating Value
export function getRatingValue(compData) {
    let ratingNumber =
        Number(compData['avg_rating'] || 0) ||
        Number(compData['self_rating'] || 0) ||
        Number(compData['rating'] || 0);

    return(Number(ratingNumber.toFixed(1)));
}
// endregion

// region Function - Get Cuisine Text
export function getCuisineText(truckData, maxDisplayCuisine = 2) {
    let cuisineText = '';

    if (truckData.cuisine) {
        if (Array.isArray(truckData.cuisine)) {
            if (truckData.cuisine.length > 0) {
                cuisineText = truckData.cuisine.map((item, index) => (index < maxDisplayCuisine) && (item?.name || '')).filter((item) => item).join(', ');
                if (truckData.cuisine.length > maxDisplayCuisine) cuisineText += ' +' + (truckData.cuisine.length - maxDisplayCuisine).toString();
            }
            else cuisineText = 'Unknown Cuisine';
        }
        else cuisineText = truckData.cuisine.toString();
    }
    else cuisineText = '';

    return cuisineText;
}
// endregion

// region Get Resize Mode String
export function getResizeMode(obj, imageWidth, isActivity) {
    return(
        isActivity ?
            (
                obj.pictures ?
                    (
                        obj.pictures[0].thumbnails && obj.pictures[0].thumbnails.large ?
                            (
                                (obj.pictures[0].thumbnails.large.width - imageWidth >= 50) && (obj.pictures[0].thumbnails.large.height - (imageWidth * 0.5625) >= 50) ?
                                    'cover'
                                    :
                                    'center'
                            )
                            :
                            'cover'
                    )
                    :
                    'cover'
            )
            :
            'cover'
    );
}
// endregion

// region Function - Check if truck is pending approval
export function isProfilePendingApproval() {
    return(GLOBAL.DATA.USER?.status === 'in-review');
}
// endregion

// region Function - Check if vendor has failed payment on Stripe
export function hasSubscriptionPaymentFailure() {
    return(
        GLOBAL.DATA.USER?.['subscription_payment_failed'] > 0 ||
        GLOBAL.DATA.USER?.['stripe_failed_payment_count'] > 0
    );
}
// endregion

// region Function - Check if vendor doesn't have any added payment method
export function hasNoCardAdded() {
    return(
        (GLOBAL.DATA.USER?.['status'] === 'active') &&
        (GLOBAL.DATA.USER?.['tier'] > 0) &&
        !GLOBAL.DATA.USER?.['subscription_payment_failed'] &&
        !GLOBAL.DATA.USER?.['total_stripe_cards']
    );
}
// endregion

// region Function - Check if truck is paused (with an upcoming subscription date)
export function hasPausedStatus() {
    return(
        (GLOBAL.DATA.USER['status'] === 'paused') &&
        !!GLOBAL.DATA.USER['subscription_start_date']
    );
}
// endregion

// region Function - Get Subscription Start Date
export function getSubscriptionDateStr(getMomentObj = false) {
    const subDateMoment = moment
        .tz(`${GLOBAL.DATA.USER['subscription_start_date']?.substring(0, 10)} 12:00`, 'America/Los_Angeles')
        .tz(getTimeZone());

    return getMomentObj ? subDateMoment : subDateMoment.format('MM/DD/YYYY');
}
// endregion

// region Function - Check if is Free Trial (and already selected tier)
export function vendorFreeTrialCheck() {
    return({
        isFreeTrial: GLOBAL.DATA.USER?.['status'] === 'free-trial',
        selectedTier: GLOBAL.DATA.USER['after_trial_tier'] || 0
    });
}
// endregion

// region Function - Check if account is test account on prod
export function isProdTestAccount() {
    return(GLOBAL.DATA.USER['email'] === 'gotruckster@gmail.com');
}
// endregion

// region Get Profile Tab's message
export function getProfileTabWarningMessage() {
    const isPendingApproval = isProfilePendingApproval();
    const isFailedPayment = hasSubscriptionPaymentFailure();
    const isNoCardAdded = hasNoCardAdded();
    const isPaused = hasPausedStatus();
    const freeTrialData = vendorFreeTrialCheck();

    let message = '';
    if (isProdTestAccount()) {
        message = '';
    }
    else if (isPendingApproval) {
        message = 'Your profile is pending approval';
    }
    else if (isNoCardAdded) {
        message =
            'Your account currently does not have a saved payment method, ' +
            'please add one ASAP to keep your access to Truckster Vendor.' +
            '\n\nPlease click here to add your payment information.' +
            '\n\nContact us at ';
    }
    else if (isFailedPayment) {
        message =
            'Your subscription payment failed. Update your payment method or add funds to your payment account ASAP so you don’t lose access.' +
            '\n\nPlease click here to update your payment information.' +
            '\n\nContact us at ';
    }
    else if (isPaused) {
        message =
            'Your account is currently paused.' +
            `\n\nYou have limited access to events and opportunities until your subscription resumes on ${getSubscriptionDateStr()}.` +
            '\n\nContact us at ';
    }
    else if (freeTrialData.isFreeTrial) {
        if (freeTrialData.selectedTier > 0) {
            message = 'Your account is on Free Trial';
        }
        else {
            message =
                'Your account is on Free Trial. Please click here to pre-select your subscription tier after this period.' +
                '\n\nContact us at ';
        }
    }

    return({
        message,
        hasContact: message.includes('Contact us at'),
        isPendingApproval,
        isFailedPayment,
        isNoCardAdded,
        isPaused,
        freeTrialData
    });
}
// endregion
